(() => {
  const observedCarousels = new WeakSet();

  function roundRatings(carousel) {
    carousel.querySelectorAll('.jdgm-header .jdgm-rating-text').forEach((rating) => {
      const text = Array.from(rating.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()
      );
      const match = text?.nodeValue.match(/^(\s*)(\d+(?:[.,]\d+)?)(\s*)$/);
      if (!match) return;

      const value = Number(match[2].replace(',', '.'));
      if (!Number.isFinite(value) || value < 0 || value > 5) return;

      let rounded = (Math.round((value + Number.EPSILON) * 10) / 10).toFixed(1);
      if (match[2].includes(',')) rounded = rounded.replace('.', ',');

      const next = match[1] + rounded + match[3];
      if (text.nodeValue !== next) text.nodeValue = next;
    });
  }

  function initialize(root) {
    const carousels = root.querySelectorAll('.jdgm-cards-carousel');
    carousels.forEach((carousel) => {
      if (observedCarousels.has(carousel)) return;
      observedCarousels.add(carousel);
      roundRatings(carousel);

      new MutationObserver(() => roundRatings(carousel)).observe(carousel, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
